import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  ref: "elementSmall",
  class: "timeline"
}
const _hoisted_2 = /*#__PURE__*/_createStaticVNode("<div class=\"sound-wave\"><div class=\"line\"></div></div><div class=\"sound-wave small\"><div class=\"wave\"></div><div class=\"wave\"></div><div class=\"wave\"></div><div class=\"wave\"></div><div class=\"wave\"></div></div><div class=\"sound-wave small reverse\"><div class=\"wave\"></div><div class=\"wave\"></div><div class=\"wave\"></div><div class=\"wave\"></div><div class=\"wave\"></div></div><div class=\"sound-wave\"><div class=\"line\"></div><div class=\"line\"></div></div>", 4)
const _hoisted_6 = [
  _hoisted_2
]
const _hoisted_7 = {
  key: 1,
  ref: "element",
  class: "timeline"
}
const _hoisted_8 = /*#__PURE__*/_createStaticVNode("<div class=\"sound-wave\"><div class=\"line\"></div></div><div class=\"sound-wave large\"><div class=\"wave\"></div><div class=\"wave\"></div><div class=\"wave\"></div><div class=\"wave\"></div><div class=\"wave\"></div><div class=\"wave\"></div><div class=\"wave\"></div><div class=\"wave\"></div><div class=\"wave\"></div><div class=\"wave\"></div><div class=\"wave\"></div><div class=\"wave\"></div><div class=\"wave\"></div></div><div class=\"sound-wave\"><div class=\"line\"></div></div><div class=\"sound-wave small reverse\"><div class=\"wave\"></div><div class=\"wave\"></div><div class=\"wave\"></div><div class=\"wave\"></div><div class=\"wave\"></div></div><div class=\"sound-wave\"><div class=\"line\"></div><div class=\"line\"></div></div>", 5)
const _hoisted_13 = [
  _hoisted_8
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_ctx.size)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, _hoisted_6, 512))
    : (_openBlock(), _createElementBlock("div", _hoisted_7, _hoisted_13, 512))
}